import React, {Fragment} from 'react';

import './PageBodyWrapper.scss'
import BackButton from "root/BackButton";

const PageBodyWrapper = ( { backButton, title, children }) =>
{
    const backButtonRender = () =>
    {
        return backButton === true ? <BackButton/> : false ;
    }

    return (
        <Fragment>
            <div className='content-pane-view'>
                <div>{backButtonRender()} </div>
                <h3>{title}</h3>
                { children }
                <div></div>
            </div>
        </Fragment>

    )
}

export default PageBodyWrapper;
